import router from './router';
export {router};

export function useRouter() {
  return router;
}
